import { useState } from "react";
import FilterService from "../services/api/filter-service";
import FilterSErvice from "../services/api/filter-service";


const useFilters = () => {

    const [listProducts, setListProducts] = useState(null);
    const [listUserTypes, setListUserTypes] = useState(null);
    const [listOfCountry, setListOfCountry] = useState(null);
    const [regionList, setRegionList] = useState(null);
    const [listOfProvince ,setListOfProvince] = useState(null);
    const [listOfCityMuni ,setListOfCityMuni] = useState(null);
    const [emailList, setEmailList] = useState([]);
    const [moduleList, setModuleLIst] = useState([])
    const [fraudTypeList, setFraudTypeList] = useState([]);

    const getListFilterProduct = () => {
        FilterService.getDistictProducts().then((res)=>{
            console.log('get product list aaaaaaa', res)
            if(res.data.success){
                setListProducts(res.data.data)
            }
        }).catch((error)=>{
            console.log('error filter product errrrr', error)
        })
    }

    const getUserTypes = () => {
        FilterService.getUserTypes().then((res)=>{
            console.log("getUserTypes data xxxx", res)
            if(res.data.success){
                setListUserTypes(res.data.data)
            }
        }).catch((error)=>{
            console.log('error  user type errrrr', error)
        })
    }

    const getCountry = () => {
        FilterService.getCountry().then((res)=>{
            console.log('get country data xxxx', res.data.data)
            if(res.data.success){
                setListOfCountry(res.data.data)
            }
        }).catch((error)=>{
            console.log('get country error xxxx', error)
        })
    }

    const getRegion = (country) => {
        FilterService.getRegion(country).then((res)=>{
            console.log('get region list aaaaaaa', res.data.data)
            if(res.data.success){
                setRegionList(res.data.data)
            }
        }).catch((error)=>{
            console.log('error region errrrr', error)
        })
    }

    const getProvince = (country, region) => {
        FilterService.getProvince(country, region).then((res)=>{
            console.log('get province list aaaaaaa', res.data.data)
            if(res.data.success){
                setListOfProvince(res.data.data)
            }
        }).catch((error)=>{
            console.log('error province errrrr', error)
        })
    }

    const getCityMunicipality = (country, region, province) => {
        FilterService.getCityMunicipality(country, region, province).then((res)=>{
            console.log('get city municipality list aaaaaaa', res.data.data)
            if(res.data.success){
                setListOfCityMuni(res.data.data)
            }
        }).catch((error)=>{
            console.log('error city municipality errrrr', error)
        })
    }

    
    const getUserEmail = () => {
        FilterService.getUserEmail().then((res)=>{
            console.log('get getUserEmail aaaaaaa', res.data.data)
            if(res.data.success){
                setEmailList(res.data.data)
            }
        }).catch((error)=>{
            console.log('error getUserEmail errrrr', error)
        })
    }

    const getModule = () => {
        FilterService.getModule().then((res)=>{
            console.log('get getModule aaaaaaa', res.data.data)
            if(res.data.success){
                setModuleLIst(res.data.data)
            }
        }).catch((error)=>{
            console.log('error getModule errrrr', error)
        })
    }

    const getDistinctFraudType = () => {
        FilterService.getDistinctFraudType().then((res) => {
            console.log("getDistinctFraudType data xxxx", res);

            if (res.data.success){
                setFraudTypeList(res.data.data)
            }
        }).catch((error) => {
            console.log("getDistinctFraudType error xxxx", error)
        })
    }


    return {
        getListFilterProduct, listProducts, getUserTypes, listUserTypes, getCountry, listOfCountry, getRegion, regionList, getProvince, listOfProvince, getCityMunicipality, listOfCityMuni,
        getUserEmail, emailList, getModule, moduleList, fraudTypeList, getDistinctFraudType,
    }
}

export default useFilters;